import {Dispatch, FC, useCallback, useState} from 'react';
import {AreBlocksExpandedProps, AvailableFiltersProps} from './types';
import MaterialDateTimePicker from '../common/date_time_picker/DateTimePicker';
import dayjs from 'dayjs';

interface ExpandableDateFilterBlockProps {
  filterItem: {
    title: string,
    filterType: string
  };
  allFilters: AvailableFiltersProps,
  setAllFilters: Dispatch<AvailableFiltersProps>,
  areBlocksExpanded: AreBlocksExpandedProps,
  setAreBlocksExpanded: Dispatch<AreBlocksExpandedProps>
}

const ExpandableDateFilterBlock: FC<ExpandableDateFilterBlockProps> = ({
  filterItem,
  allFilters,
  setAllFilters,
  areBlocksExpanded,
  setAreBlocksExpanded

}) => {
  const {title, filterType} = filterItem;
  const [appointmentAfterError, setAppointmentAfterError] = useState(false);
  const [appointmentBeforeError, setAppointmentBeforeError] = useState(false);

  const handleDateTimeChange = useCallback(({date, fieldName, setError}) => {
    setError(!!date && !dayjs(date).isValid());

    setAllFilters({
      ...allFilters,
      [fieldName]: dayjs(date).toDate()
    });
  }, [allFilters]);

  return (
    <div className="expandable-block">
      <ul className="filters-list">
        <li
          className="filters-list-row cursor-pointer space-between"
          onClick={() => setAreBlocksExpanded({
            ...areBlocksExpanded,
            [filterType]: !areBlocksExpanded[filterType]
          })}>
          <span className="bold-text">
            {title}
          </span>
          <span className="bold-text">
            {areBlocksExpanded[filterType] ? '-' : '+'}
          </span>
        </li>
        {areBlocksExpanded[filterType] &&
          <>
            <li className="filters-list-row space-between">
              <span className="item-text">Scheduled After</span>
              <MaterialDateTimePicker
                value={allFilters['APPOINTMENT_AFTER']}
                label="Appointment Date"
                onChange={(date) => {
                  handleDateTimeChange({date: date, fieldName: 'APPOINTMENT_AFTER', setError: setAppointmentAfterError});
                }}
                showError={appointmentAfterError}
              />
            </li>
            <li className="filters-list-row space-between">
              <span className="item-text">Scheduled Before</span>
              <MaterialDateTimePicker
                value={allFilters['APPOINTMENT_BEFORE']}
                label="Appointment Date"
                onChange={(date) => {
                  handleDateTimeChange({date: date, fieldName: 'APPOINTMENT_BEFORE', setError: setAppointmentBeforeError});
                }}
                showError={appointmentBeforeError}
              />
            </li>
          </>
        }
      </ul>
    </div>
  );
};

export default ExpandableDateFilterBlock;
